import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, FlexRow, H5 } from '@contently/toolkit';
import useFilter from './useFilter';

const regions = ['All', 'US', 'Canada'];
export default function Filter({ filterState, setFilterState }) {
  const TriggerButton = () => (
    <FlexRow margin="small">
      <span>
        <H5>{filterState}</H5>
      </span>
    </FlexRow>
  );

  const dropdownActions = useFilter(filterState, setFilterState, 'contentValueRegion', regions);

  return <Dropdown links={dropdownActions} Trigger={TriggerButton} id="filter-trigger" fullWidth triggerArrow />;
}

Filter.propTypes = {
  filterState: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/filter.jsx